<script lang="ts">
    import {getGridContext} from 'shared/ui-widgets/grid/grid.context';

    export let additionalClasses = '';
    export let additionalContainerClasses = '';

    const {settings} = getGridContext();
</script>

<div class="kp-generic-grid-container {additionalContainerClasses}"
     class:responsive={true}
     class:bordered={true}>

    <div role="grid"
         tabindex="0"
         class="kp-generic-grid {additionalClasses}"
         class:sticky-header={settings.stickyHeader}>

        {#if $$slots.header}
            <div class="header">
                <slot name="header"/>
            </div>
        {/if}

        <div class="body">
            <slot name="body"/>
        </div>


        {#if $$slots.footer}
            <div class="footer">
                <slot name="footer"/>
            </div>
        {/if}
    </div>
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .kp-generic-grid-container {
        &.bordered {
            border: 1px solid @table-border-color;
            border-radius: @border-radius-base;
        }

        &.responsive {
            overflow-x: auto;
            width: 100%;
        }
    }

    .kp-generic-grid {
        background-color: @table-bg;
        width: 100%;
        max-width: 100%;
        margin-bottom: 0;

        &.sticky-header {
            .header {
                background-color: @body-bg;
                position: sticky;
                top: 0;
                z-index: 90;
            }
        }
    }
</style>